import script from "./GlobusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusBadge.vue?vue&type=script&setup=true&lang=js"

import "./GlobusBadge.vue?vue&type=style&index=0&id=48f6d4d3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f6d4d3"]])

export default __exports__